module.exports = __webpack_public_path__ + "img/一六八八.19c22a7e.svg";